/**
 * Display labels for the two roles an organization can hold.
 *
 * "Coach" and "Organization admin" rather than the stored `user` and `admin`, matching what the
 * API's assignable-roles endpoint returns and what the organization's own settings screen shows —
 * the same person must not be a "user" on the platform admin page and a "Coach" on theirs.
 */
export const ROLE_COACH = "Coach";
export const ROLE_ORG_ADMIN = "Organization admin";
export const ROLE_PLATFORM_ADMIN = "Platform admin";

/** Stored role for a display label. Anything unrecognised falls back to the least privileged. */
export const roleKeyFromLabel = (label: string): string =>
  label === ROLE_ORG_ADMIN ? "admin" : "user";

/** Display label for a stored role. */
export const roleLabelFromKey = (role: string): string =>
  role === "admin"
    ? ROLE_ORG_ADMIN
    : role === "system_admin"
      ? ROLE_PLATFORM_ADMIN
      : ROLE_COACH;
